// extracted by mini-css-extract-plugin
export default {"filterContainer":"SidePanel_filterContainer__g8EWR"};